(function (angular) {
    'use strict';
 
    angular.module('app')
        .value('channelsProvider', {
            appMessaging: { 
                name: 'App Messaging', 
                allowed: false
            },
            sms: { 
                name: 'SMS', 
                allowed: false,
                permissionsRead:["apis:smsconf:r"]
            },
            mms: { 
                name: 'MMS', 
                allowed: false
            },
            twitterDm: { 
                name: 'Twitter DM', 
                allowed: false,
                permissionsRead:["twitr:r"],
                permissionsWrite:["twitr:w"]
            },
            email: { 
                name: 'Email', 
                allowed: false,
                permissionsRead:["email:r"],
                permissionsWrite:["email:w"] 
             },
            fbMessenger: { 
                name: 'Facebook Messenger', 
                allowed: false,
                permissionsRead:["fb:r"],
                permissionsWrite:["fb:w"] 
            },
            whatsApp: { 
                name: "WhatsApp", 
                allowed: false ,
                permissionsRead:["wtapp:r"],
                permissionsWrite:["wtapp:w"]
            },
            rcs: { 
                name: "RCS", 
                allowed: false,
                permissionsRead:["rcs:r"],
                permissionsWrite:["rcs:w"]
            }
        })


        .value('messageDataReportsFields', {
            common:[
                "messageId",
                "submittedOn",
                "profileId",
                "channelId",
                "direction",
                "message.body",
                "message.title",
                "message.conversationId",
                "message.metadata.comapiSystem",
                "message.messageParts",
                "message.metadata.chatId",
                "message.metadata.sentByAgent",
                "message.metadata.broadcastId",
                "status"
            ],
            whatsApp: ["profile.phoneNumber"],
            appMessaging: [],
            sms: ["profile.phoneNumber"],
            twitterDm: [  "profile.twitterUsername"],
            email: [  "profile.email"],
            fbMessenger: ["profile.fbMessengerId"],
            rcs: ["profile.phoneNumber"],
            nativePush: ["message.customBody"]
        })
        .value("customChannels",{});


})(window.angular);